import { gql } from 'graphql-request';

export const CREATE_RATING_MUTATION = gql`
  mutation CreateRating($input: CreateRatingInput!) {
    createRating(input: $input) {
      id
    }
  }
`;
